import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_COUNT,
} from "../../constants/action.constants";
import { getAccessToken } from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { postDashboardWebApi } from "../../webApis/apiResource";

export const requestNotifications = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      dispatch(fetchNotications(response.data));
    }
  };
};

export const requestNotificationsCount = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      dispatch(fetchNotificationsCount(response.data.data));
    }
  };
};

const fetchNotications = (resp) => {
  const { data, ...others } = resp;
  return {
    type: FETCH_NOTIFICATIONS,
    payload: data,
    others,
  };
};

const fetchNotificationsCount = (data) => {
  return {
    type: FETCH_NOTIFICATIONS_COUNT,
    payload: data,
  };
};
